__turbopack_context__.v({
  "description": "WithUsSection-module-scss-module__Qn0fua__description",
  "leftArrow": "WithUsSection-module-scss-module__Qn0fua__leftArrow",
  "newsSection": "WithUsSection-module-scss-module__Qn0fua__newsSection",
  "partners": "WithUsSection-module-scss-module__Qn0fua__partners",
  "partnersWrapper": "WithUsSection-module-scss-module__Qn0fua__partnersWrapper",
  "rightArrow": "WithUsSection-module-scss-module__Qn0fua__rightArrow",
  "title": "WithUsSection-module-scss-module__Qn0fua__title",
});
